import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Form, Select, Typography } from "antd";
import { selectAssigneesAndUserGroups } from "../../store/selector";
import { SingleSelect } from "../customComponent/CustomSelect";
import { formatAssignee } from "../../utils/formaters";

const { Text } = Typography;
const { Option } = Select;

const AssigneeFormItemComponent = ({
  t,
  assignees,
  defaultValue,
  title,
  style,
  showLabel = false,
  editable = true,
  strong = false,
  required = false
}) => (
  <Form.Item
    name="assignee"
    colon={false}
    label={
      showLabel ? (
        <Text strong={strong} style={{ color: "#9B9B9B" }}>
          {title ? title : t("form.assignee.label")}
        </Text>
      ) : null
    }
    rules={[{ required: required, message: t("new_patient.assignee_required") }]}
    style={style}
  >
    {editable ? (
      <SingleSelect
        allowClear
        defaultValue={defaultValue}
        placeholder={t("form.assignee.placeholder")}
        showSearch={true}
        getPopupContainer={() => document.body}
      >
        {assignees.map((assignee) => (
          <Option key={assignee.id} value={String(assignee.id)}>
            {formatAssignee(assignee)}
          </Option>
        ))}
      </SingleSelect>
    ) : (
      <Text>{defaultValue ? defaultValue : t("patient.general.assignee_placeholder")}</Text>
    )}
  </Form.Item>
);

const mapStateToProps = createStructuredSelector({
  assignees: selectAssigneesAndUserGroups
});

const AssigneeFormItem = connect(mapStateToProps)(withTranslation()(AssigneeFormItemComponent));

export { AssigneeFormItem };
